module.exports = __webpack_public_path__ + "static/media/om-oss.1c542f36.jpg";